import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { RegistrationService } from 'src/shared/services/registration.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registration-approver',
  templateUrl: './registration-approver.component.html',
  styleUrl: './registration-approver.component.scss'
})
export class RegistrationApproverComponent implements OnInit {

  paramForm: FormGroup;
  data: any[] = [];
  columnsToDisplay = ['school_program_name','activity_name','student_name', 'period', 'date'];
  sort = 'asc';
  orderBy = 'activity_name';
  subscription: Subscription;
  loading = false;
  periodSelected: any;
  periodList: any;

  searchText = '';
  filterPaid: boolean | null = null;
  isManualPayment: boolean | null = null;

  constructor(
    private registService: RegistrationService,
    private rpSer: ResponseService,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    if (this.auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_REJECT'] || this.auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_APPROVE']) {
      this.columnsToDisplay.push('action');
    }
    this.initForm();
    this.getPeriodList();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'school_program_activity_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'period_id': new FormControl(null)
    });
  }

  onChangeAcademicYear(item: any) {

    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);

    // this.getRegistrationData();

  }

  onChangeSchoolLevel(item: any) {

    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['year_level_id'].setValue(null);

    this.getRegistrationData();

  }

  onChangeSchoolProgram(item: any) {

    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_category_id'].setValue(null);

    this.getRegistrationData();

  }

  onChangeSchoolProgramCategory(item: any) {

    this.paramForm.controls['school_program_category_id'].markAsTouched();
    this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);
    this.getRegistrationData();

  }

  onChangeSchoolProgramActivity(item: any) {
    this.paramForm.controls['school_program_activity_id'].markAsTouched();
    this.paramForm.controls['school_program_activity_id'].setValue(item ? item.school_program_activity_id : null);
    this.getRegistrationData();
  }

  onChangePeriod(item: any) {
    this.paramForm.controls['period_id'].markAsTouched();
    this.paramForm.controls['period_id'].setValue(item ? item.period_id : null);

    this.getRegistrationData();
  }

  getPeriodList() {
    this.registService.getPeriodList().subscribe({
      next: (response: any) => {
        if (response.status) {
          this.periodList = response.data;
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.');
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
      }
    });
  }

  onSearchChange() {
    this.getRegistrationData();
  }

  onFilterChange() {
    this.getRegistrationData();
  }

  onSort(order: string) {
    this.sort = this.sort == 'asc' ? 'desc' : 'asc';
    this.orderBy = order;
    this.getRegistrationData();
  }

  getRegistrationData() {
    this.loading= true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.data = [];
    const params = {
      school_locaiton_id: this.paramForm.get('school_location_id')?.value,
      school_program_id: this.paramForm.get('school_program_id')?.value,
      school_program_category_id: this.paramForm.get('school_program_category_id')?.value,
      school_program_activity_id: this.paramForm.get('school_program_activity_id')?.value,
      period_id: this.paramForm.get('period_id')?.value,
      sort: this.sort,
      orderBy: this.orderBy,
      search: this.searchText,
      is_paid: this.filterPaid,
      is_manual_payment: this.isManualPayment,
    }
    this.subscription = this.registService.getStudentRegistration(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.data = response.data;
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
        this.loading = false;
      }
    });
  }

  onApproveRegistration(data: any, isApprove: boolean) {
    this.registService.getPeriodV2(data.student_id).subscribe({
      next: (response: any) => {
        if (response.status) {
          const params = {
            ...data,
            period_id: data.period_id,
            period_name: this.periodList.find((i: any) => i.period_id == response.data.period_id).period_name,
            year_level_id: response.data.year_level_id,
            academic_year: response.data.academic_year,
            school_level_relation_id: response.data.school_level_relation_id,
            school_location_id: response.data.school_location_id,
          }
          // data.period_id = response.data.period_id;
          // data.period_name = this.periodList.find((i: any) => i.period_id == response.data.period_id).period_name;
          // data.year_level_id = response.data.year_level_id;
          // data.academic_year = response.data.academic_year;
          // data.school_level_relation_id = response.data.school_level_relation_id;
          this.saveApprove(params, isApprove);
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.')
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
      }
    });
  }

  saveApprove(data: any, isApprove: boolean) {
    Swal.fire({
      title: `Are you sure to ${isApprove ? 'approve' : 'reject'} this registration?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        data.is_approve = isApprove;
        this.registService.onApproveRegistration(data.activity_registration_id, data).subscribe({
          next: (response: any) => {
            if(response.status){
              this.rpSer.showAddSuccess(`Registration has been ${isApprove ? 'approved' : 'rejected'}.`); 
              this.getRegistrationData();
            } else {
              this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.');
            }
          },
          error: (error: any) => {
            this.rpSer.showAddError();
          }
        });
      }
    });
  }


}
